export const NationalMsgPreivew = () => {
  return <div>preview</div>;
};
